/** The marker the app appends to a link it claimed but could not show. */
export const NO_APP_PARAM = 'no_app'

/**
 * Read the marker as *presence*, never `=== '1'`. The app only ever writes `1`, but a loose read
 * fails in the safe direction: an unrecognised value keeps the reader on the web, where the page
 * works, rather than handing them back to the app that has already declined this link.
 */
export const hasNoApp = (search: string | null | undefined): boolean => {
  if (!search) return false
  return new URLSearchParams(stripLeadingQuestionMark(search)).has(NO_APP_PARAM)
}

/**
 * Carry the marker from a request onto the search of wherever it is being sent. A hop that drops
 * it looks unmarked, so the app claims it again and the reader bounces between the two.
 *
 * @returns a search that is either empty or `?`-prefixed, whichever form it was given.
 */
export const carryNoApp = (from: string | null | undefined, to: string | null | undefined): string => {
  const target = to ?? ''
  if (!hasNoApp(from) || hasNoApp(target)) return withLeadingQuestionMark(target)

  const params = new URLSearchParams(stripLeadingQuestionMark(target))
  params.set(NO_APP_PARAM, '1')
  return `?${params.toString()}`
}

const stripLeadingQuestionMark = (search: string) => (search.startsWith('?') ? search.slice(1) : search)

const withLeadingQuestionMark = (search: string) => {
  const bare = stripLeadingQuestionMark(search)
  return bare ? `?${bare}` : ''
}
